//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export AdminScreenConfig
export const ImportBalancesConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path     : '/app/agentPanel/importBalances',
      component: FuseLoadable({
          loader: () => import('./ImportBalances')
      })
  }
  ]
  //end routes
};
